<div class="tw-relative tw-pt-8 tw-pb-8">
  <div class="tw-absolute tw-top-3 tw-right-3 tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-cursor-pointer" (click)="closeBottomSheet()">
    <img class="tw-w-6 tw-h-6" src="/assets/icons/close-icon-bottomsheet.png" alt="close" />
  </div>

  <div class="tw-flex tw-flex-col tw-items-center">
    <div class="tw-flex tw-flex-col tw-items-center tw-gap-5">
      <div class="tw-flex tw-flex-col tw-items-center tw-gap-1 tw-w-[302px]">
        <div class="tw-w-7 tw-h-7 tw-rounded-[29px] tw-overflow-hidden">
          <div class="tw-w-7 tw-h-7 tw-rounded-[29px] tw-overflow-hidden">
            <div class="tw-w-[28px] tw-h-[28px] tw-rounded-full tw-overflow-hidden tw-flex tw-justify-center tw-items-center">
              <img src="/assets/gifs/tick-white-no-bg.gif" alt="tick" />
            </div>
          </div>
        </div>
        <p class="tw-font-lexend tw-font-bold tw-text-[24px] tw-leading-[28.8px] tw-text-black tw-text-center tw-capitalize tw-w-[248px]" i18n="@@paymentLinkGenerated">Payment Link Generated!</p>
        <p class="tw-font-lexend tw-font-normal tw-text-[12px] tw-leading-[14px] tw-text-gray-500 tw-text-center" i18n="@@chooseHowMuch">Choose how much your friend/ family pays online</p>
      </div>

      <div class="tw-flex tw-flex-col tw-gap-3">
        <div class="tw-relative tw-border tw-border-solid tw-rounded-[16px] tw-w-[312px] tw-h-[88px] tw-overflow-hidden tw-cursor-pointer tw-pt-[36px] tw-px-[14px]"
             [class]="selectedOption === PAYMENT_OPTION.COD_FEE ? 'tw-border-[#0e796c]' : 'tw-border-gray-400'"
             (click)="selectOption(PAYMENT_OPTION.COD_FEE)">
          <div class="tw-absolute tw-top-[-1px] tw-left-[13px] tw-h-5 tw-rounded-bl-[6px] tw-rounded-br-[6px] tw-flex tw-items-center tw-justify-center tw-px-2 tw-bg-[#f9e7d7]">
            <span class="tw-font-lexend tw-font-medium tw-text-[10px] tw-leading-[16px] tw-tracking-[1px] tw-uppercase tw-text-[#bf501f]" i18n="@@codFeeTag">COD FEE</span>
          </div>
          <div class="tw-flex tw-items-start tw-justify-between">
            <div class="tw-flex tw-flex-col tw-gap-0.5">
              <p class="tw-font-lexend tw-font-bold tw-text-[16px] tw-leading-[18px] tw-text-black" i18n="@@pay50Online">Pay ₹{{codFee}} online</p>
              <p class="tw-font-body tw-font-normal tw-text-[12px] tw-leading-[16px] tw-text-gray-500" i18n="@@remainingAsCod">Remaining ₹{{remainingAmount | number}} as cash on delivery</p>
            </div>
            <div class="tw-w-4 tw-h-4 tw-rounded-full tw-border tw-border-solid tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-mt-0.5"
                 [class]="selectedOption === PAYMENT_OPTION.COD_FEE ? 'tw-border-[#0e796c]' : 'tw-border-gray-400'">
              @if (selectedOption === PAYMENT_OPTION.COD_FEE) {
                <div class="tw-w-2.5 tw-h-2.5 tw-rounded-full tw-bg-[#0e796c]"></div>
              }
            </div>
          </div>
        </div>

        <div class="tw-relative tw-border tw-border-solid tw-rounded-[16px] tw-w-[312px] tw-h-[88px] tw-overflow-hidden tw-cursor-pointer tw-pt-[36px] tw-px-[14px]"
             [class]="selectedOption === PAYMENT_OPTION.FULL_PAYMENT ? 'tw-border-[#0e796c]' : 'tw-border-gray-400'"
             (click)="selectOption(PAYMENT_OPTION.FULL_PAYMENT)">
          <div class="tw-absolute tw-top-[-1px] tw-left-[13px] tw-h-5 tw-rounded-bl-[6px] tw-rounded-br-[6px] tw-flex tw-items-center tw-justify-center tw-px-2 tw-bg-teal-100">
            <span class="tw-font-lexend tw-font-medium tw-text-[10px] tw-leading-[16px] tw-tracking-[1px] tw-uppercase tw-text-[#0e796c]"
                  i18n="@@fullPaymentTag">FULL PAYMENT</span>
          </div>
          <div class="tw-flex tw-items-start tw-justify-between">
            <div class="tw-flex tw-flex-col tw-gap-0.5">
              <p class="tw-font-lexend tw-font-bold tw-text-[16px] tw-leading-[18px] tw-text-black" i18n="@@payFullOnline">Pay ₹{{orderSP | number}} online</p>
              <p class="tw-font-body tw-font-normal tw-text-[12px] tw-leading-[16px] tw-text-gray-500" i18n="@@nothingOnDelivery">Nothing to pay on delivery</p>
            </div>
            <div class="tw-w-4 tw-h-4 tw-rounded-full tw-border tw-border-solid tw-flex-shrink-0 tw-flex tw-items-center tw-justify-center tw-mt-0.5"
                 [class]="selectedOption === PAYMENT_OPTION.FULL_PAYMENT ? 'tw-border-[#0e796c]' : 'tw-border-gray-400'">
              @if (selectedOption === PAYMENT_OPTION.FULL_PAYMENT) {
                <div class="tw-w-2.5 tw-h-2.5 tw-rounded-full tw-bg-[#0e796c]"></div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-mt-6">
      <button csButton
              type="button"
              class="tw-w-[312px]"
              style="border-radius: 12px !important;"
              (click)="onShareLink()"
              i18n="@@sharePaymentLinkWithAmount"
      >Share ₹{{selectedAmount | number}} payment link</button>
    </div>
  </div>
</div>
